import React from 'react';

const CommonIconRadio = ({
    name,
    id,
    value,
    label,
    leftIcon,
    onChange,
    checked,
    disabled = false,
    errors = {},
    className = '',
    labelClassName = 'mb-0',
    containerClassName = 'd-flex align-items-center justify-content-between p-2 border rounded shadow-sm h-100 position-relative cursor-pointer',
    tickContainerClassName = 'tick_container',
    tickClassName = 'tick',
    iconClassName = 'me-2'
}) => {
    const error = errors[name];

    return (
        <div className={`${className}`}>
            <input
                type="radio"
                name={name}
                id={id}
                className="d-none imgbgchk"
                value={value}
                onChange={onChange}
                checked={checked}
                disabled={disabled}
            />
            <label 
                className={containerClassName} 
                htmlFor={id}
            >
                <div className="d-flex align-items-center">
                    {leftIcon && (
                        <i className={`${leftIcon} ${iconClassName}`}></i>
                    )}
                    {label && (
                        <div className={labelClassName}>{label}</div>
                    )}
                </div>
                <div className={tickContainerClassName}>
                    <div className={tickClassName}>
                        <i className="fa fa-check"></i>
                    </div>
                </div>
            </label>
            {error && (
                <div className="invalid-feedback d-block">
                    {error}
                </div>
            )}
        </div>
    );
};

export default CommonIconRadio; 